import { HttpClient } from '@angular/common/http';
import { SERVER_API_URL } from '../../../app.constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class PasswordResetFinishService {
    constructor(http) {
        this.http = http;
    }
    save(key, newPassword) {
        return this.http.post(SERVER_API_URL + 'api/account/reset-password/finish', { key, newPassword });
    }
}
PasswordResetFinishService.ɵfac = function PasswordResetFinishService_Factory(t) { return new (t || PasswordResetFinishService)(i0.ɵɵinject(i1.HttpClient)); };
PasswordResetFinishService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PasswordResetFinishService, factory: PasswordResetFinishService.ɵfac, providedIn: 'root' });
